import { render, staticRenderFns } from "./updatePwd.vue?vue&type=template&id=03eb9d34&"
import script from "./updatePwd.vue?vue&type=script&lang=js&"
export * from "./updatePwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports